import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';

// UTILS
import { trackById } from '../../../shared/util/track-by.util';

@Component({
  selector: 'lum-rfq-scan-mode-input',
  templateUrl: './rfq-scan-mode-input.component.html',
  styleUrls: ['./rfq-scan-mode-input.component.scss'],
})
export class RfqScanModeInputComponent implements OnInit, OnDestroy {
  @Input()
  loading :boolean = false;

  @Input()
  rfqs :any[] = [];

  @Input()
  debounceTime :number = 500;

  @Input()
  disabled :boolean = false;

  @Input()
  scanSearchStr :UntypedFormControl = new UntypedFormControl();

  @Output()
  inputChangeEvent = new EventEmitter<string>();

  @Output()
  selectSkuEvent = new EventEmitter<any>();

  private scanSearchUpdated$ = new Subject<string>();
  private onDestroy$ = new Subject();

  trackById = trackById;

  ngOnInit() :void {
    this.onScanSearchUpdate().subscribe();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onSearchRfqs(event :any) :void {
    this.scanSearchUpdated$.next(event.target.value);
  }

  onSelectSku(event :MatAutocompleteSelectedEvent) :void {
    this.selectSkuEvent.emit({ ...event.option.value, quantity: 1 });
  }

  displayFnRfq(option :any) :string {
    return option && option.sku ? `${option.product_name}[${option.sku}]` : '';
  }

  private onScanSearchUpdate() :Observable<string> {
    return this.scanSearchUpdated$.asObservable().pipe(
      distinctUntilChanged(),
      debounceTime(this.debounceTime),
      tap((scanSearchStr :string) => {
        this.inputChangeEvent.emit(scanSearchStr);
      }),
      takeUntil(this.onDestroy$),
    );
  }
}
